import { IJsonQuery } from '@cian/api-models/common/json_query';
import * as R from 'ramda';

import { NonEmptyArray, EBalconyType } from './types';
import { getRangeValue, setTerm, setRangeMin, resetTerms } from './helpers';

export function setBalconyTypes(jsonQuery: IJsonQuery) {
  return (balconyTypes: NonEmptyArray<EBalconyType> | null): IJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    nextJsonQuery = resetTerms(['balconies', 'loggia'])(nextJsonQuery);

    if (balconyTypes) {
      if (balconyTypes.includes(EBalconyType.Balcony)) {
        const balconies = getRangeValue('balconies')(jsonQuery);

        nextJsonQuery = setRangeMin('balconies')(nextJsonQuery)((balconies && balconies.gte) || 1);
      }

      if (balconyTypes.includes(EBalconyType.Loggia)) {
        nextJsonQuery = setTerm('loggia')(nextJsonQuery)(true);
      }
    }

    return nextJsonQuery;
  };
}
